import { render, staticRenderFns } from "./add-sitePenalty.vue?vue&type=template&id=c3d01be2&scoped=true&"
import script from "./add-sitePenalty.vue?vue&type=script&lang=js&"
export * from "./add-sitePenalty.vue?vue&type=script&lang=js&"
import style0 from "./add-sitePenalty.vue?vue&type=style&index=0&id=c3d01be2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d01be2",
  null
  
)

export default component.exports